import { render } from "./refund-list.vue?vue&type=template&id=5753ddee"
import script from "./refund-list.vue?vue&type=script&lang=js"
export * from "./refund-list.vue?vue&type=script&lang=js"

import "./refund-list.vue?vue&type=style&index=0&id=5753ddee&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__